// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3siu_","checkboxCol":"Table_checkboxCol__1jlx2","emailCol":"Table_emailCol__WEJZQ","actionCol":"Table_actionCol__3lnwj"};